/* global axios */
import ApiClient from './ApiClient';

// TalkRobin: the account's plan, what it includes and how much is used.
class TalkrobinPlanAPI extends ApiClient {
  constructor() {
    super('plan', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  requestUpgrade(plan) {
    return axios.post(`${this.url}/upgrade_request`, { plan });
  }
}

export default new TalkrobinPlanAPI();
